export const setNewVsoId = ({state}, id) => {
    state.vsoForm.newVso.id = id;
}

export const clearNewVso = ({state, actions}) => {
    actions.projects.clearProjectForm();
    state.vsoForm.newVso.id = '';
    state.vsoForm.newVso.fields = [];
}

export const incrementFormStep = ({state}) => {
    let currentStep = state.vsoForm.formStep;
    currentStep++;
    state.vsoForm.formStep = currentStep;
}

export const decrementFormStep = ({state}) => {
    let currentStep = state.vsoForm.formStep;
    currentStep--;
    state.vsoForm.formStep = currentStep;
}

export const createVso = async ({state, effects}) => {
    const vsoId = await effects.vsoForm.postVso(state.currentUser.userId);
    state.vsoForm.newVso.id = vsoId;
}

export const updateVsoFields = async ({state, effects}, fieldIds) => {
    let fields = {};
    let index = 0;
    for(const contentId of fieldIds) {
        fields[index] = {
            contentId: contentId,
            value: state.vsoForm.newVso.fields[contentId].value
        }
        index++;
    }
    
    const updatedFields = await effects.vsoForm.putVsoFields(state.vsoForm.newVso.id, fields);
}

export const setVsoField = ({state}, field) => {
    state.vsoForm.newVso.fields[field.contentId] = {
        ...state.vsoForm.newVso.fields[field.contentId], 
        value: field.value
    };
}

export const pushToFieldArray = ({state}, {contentId, value}) => {
    state.vsoForm.newVso.fields[contentId].value.array.push(value);
    state.vsoForm.newVso.fields[contentId].value.array.sort(function(a, b){
        if(a < b) { return -1; }
        if(a > b) { return 1; }
        return 0;
    })
}

export const removeFromFieldArray = ({state}, {contentId, index}) => {
    state.vsoForm.newVso.fields[contentId].value.array.splice(index, 1);
}

export const loadNewVso = async ({state, effects}) => {
    try {
        const vsoFields = await effects.VSOs.fetchVsoFields(state.vsoForm.newVso.id);
        let fieldsObj = {}
        for(const f of vsoFields) {
            if(f.field_value != null) {
                fieldsObj[f.field_content_id] = 
                {
                    value: f.field_value.includes('{"') ? JSON.parse(f.field_value) : f.field_value === "true" ? true : f.field_value === "false" ? false : f.field_value,
                    comment: f.auditor_comment,
                    status: f.status,
                }
            }
        }
        state.vsoForm.newVso.fields = fieldsObj;
        /*
        state.marketTestForm.newMarketTest.fields.project_address.value = JSON.parse(state.marketTestForm.newMarketTest.fields.project_address.value);
        state.marketTestForm.newMarketTest.fields.project_desc_en.value = JSON.parse(state.marketTestForm.newMarketTest.fields.project_desc_en.value);
        state.marketTestForm.newMarketTest.fields.project_desc_fr.value = JSON.parse(state.marketTestForm.newMarketTest.fields.project_desc_fr.value); 
        */
    } catch (err) {
        console.error(err.message);
        return err;
    }
}

/*
export const getNewMarketTestFromStorage = ({state}) => {
    state.marketTestForm.newMarketTest.fields = localStorage.newMarketTestFields;
}
export const getCurrentMarketTestFromStorage = ({state}) => {
    state.marketTestForm.currentMarketTest.fields = localStorage.currentMarketTestFields;
}

export const saveNewMarketTestFields = ({state}) => {
    localStorage.set('newMarketTestFields', state.marketTestForm.newMarketTest.fields);
}
export const saveCurrentMarketTestFields = ({state}) => {
    localStorage.set('newMarketTestFields', state.marketTestForm.newMarketTest.fields);
}

export const setNewMarketTestField = ({state}, idValue, value) => {
    state.marketTestForm.currentMarketTest.fields[idValue] = value;
}

export const storeNewMarketTestField = ({state, effects}, idValue) => {
    effects.marketTestForm.storeField(state.marketTestForm.newMarketTest.fields[idValue]);
}
*/